import { hot } from 'react-hot-loader/root';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import OrgSelect from './OrgSelect';

const getRecursiveLabel = orgCode => {
  if (/111$/.test(orgCode)) {
    return 'Search entire union?';
  }

  if (/11$/.test(orgCode)) {
    return 'Search entire conference?';
  }

  return '';
};

const JobsFilter = ({ categories }) => {
  const [params, setParams] = useState({
    category_id: '',
    org_code: '',
    query: '',
    recursive: true,
  });
  const resetFilters = () => { window.location = '/opportunities'; };
  const handleFieldChange = ({ target }) => {
    setParams({
      ...params,
      [target.name]: target.type === 'checkbox' ? target.checked : target.value,
    });
  };

  useEffect(() => {
    const queryParams = queryString.parse(window.location.search);
    setParams({
      category_id: queryParams.category_id || '',
      org_code: queryParams.org_code || '',
      query: queryParams.query || '',
      recursive: queryParams.recursive === 'on' || false,
    });
  }, []);

  return (
    <form
      action="/opportunities"
      method="get"
      className="border-gray-500 p-5 shadow-sm sm:px-10 sm:py-10 bg-[#F9FAFB]"
    >
      <div className="grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-3">
        <div className="md:col-span-2 flex flex-col gap-4">
          <div>
            <label htmlFor="jobs-filter-query" className="block text-sm font-medium text-gray-700 -tracking-[.2px]">Search job title</label>
            <div className="mt-1">
              <input
                id="jobs-filter-query"
                name="query"
                onChange={handleFieldChange}
                placeholder="Search"
                type="text"
                value={params.query}
                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-[#2CB6D8] focus:outline-none focus:ring-[#2CB6D8] sm:text-sm -tracking-[.5px]"
              />
            </div>
          </div>

          <div>
            <label htmlFor="jobs-filter-category" className="block text-sm font-medium text-gray-700 -tracking-[.2px]">Filter by category</label>
            <div className="mt-1">
              <select
                id="jobs-filter-category"
                name="category_id"
                onChange={handleFieldChange}
                value={params.category_id}
                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-[#2CB6D8] focus:outline-none focus:ring-[#2CB6D8] sm:text-sm -tracking-[.5px]"
              >
                <option
                  value=""
                  className="text-gray-900 cursor-pointer py-2 pl-3 pr-9"
                >
                  Show all categories
                </option>
                {categories.map(c => (
                  <option
                    className="text-gray-900 cursor-pointer py-2 pl-3 pr-9"
                    key={c.id}
                    value={c.id}
                  >
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {params.category_id !== '6' && params.category_id !== '7' && (
            <>
              <div>
                <label htmlFor="jobs-filter-location" className="block text-sm font-medium text-gray-700 -tracking-[.2px]">
                  Filter by School, Conference, or Union
                </label>

                <div className="mt-1">
                  <OrgSelect
                    htmlName="org_code"
                    htmlClass="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-[#2CB6D8] focus:outline-none focus:ring-[#2CB6D8] sm:text-sm -tracking-[.5px]"
                    onChange={handleFieldChange}
                    selected={params.org_code}
                  />
                </div>
              </div>

              <div>
                <div className="mt-1">
                  {/11$/.test(params.org_code) && (
                    <label className="block flex gap-3 text-sm font-medium text-gray-700 -tracking-[.2px]">
                      <input
                        checked={params.recursive}
                        name="recursive"
                        onChange={handleFieldChange}
                        type="checkbox"
                        className="block rounded-md border-gray-300 p-2 text-base focus:border-[#2CB6D8] focus:outline-none focus:ring-[#2CB6D8] sm:text-sm -tracking-[.5px]"
                      />
                      {getRecursiveLabel(params.org_code)}
                    </label>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        <div className="md:col-span-1 flex-row-reverse flex md:flex-col items-center justify-start md:justify-end gap-4">
          <button
            className="flex max-w-fit -tracking-[.05em] justify-center rounded-sm bg-[#2CB6D8] py-2 px-10 text-sm text-white hover:bg-[#2CB6D8]/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            type="submit"
          >
            Apply
          </button>

          <button
            className="font-medium text-[#2CB6D8] hover:text-[#2CB6D8]/80"
            onClick={resetFilters}
            type="button"
          >
            Reset
          </button>
        </div>
      </div>
    </form>
  );
};

JobsFilter.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
};

export default hot(JobsFilter);
